import { useState, useCallback } from 'react';
import { useSpinner, useToast } from '@chikara/ui';
import { cardService } from '@/features/card/services/cardService/cardService';
import type { UseActivateCardReturn, ActivateCardRequest } from '@/features/card/types/card.types';
import { t } from '@/i18n';

export const useActivateCard = (): UseActivateCardReturn => {
    const { show, hide } = useSpinner();
    const { success } = useToast();
    const [error, setError] = useState<string | null>(null);

    const activateCard = useCallback(async (payload: ActivateCardRequest) => {
        show();
        setError(null);
        try {
            await cardService.activateCard(payload);
            success(t('dashboard.card.activateModal.result.success'));
            return true;
        } catch (err) {
            setError(t('dashboard.card.activateModal.result.error'));
            return false;
        } finally {
            hide();
        }
    }, [show, hide, success]);

    return { activateCard, error };
};
